import LogActivityDrawer from './LogActivity'

export { LogActivityDrawer }

export const MODALS = { logActivity: LogActivityDrawer }
